import { Inject, Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import {
  BaseOneResponseInterface,
  GetManyResponseInterface,
} from '../../../../shared/model/interface/crud-response-interface.model';
import {
  ILoadBalancerChannel,
  ILoadBalancerChannelPatch,
} from '../../../../view/settings/api-automation-settings/load-balancer-channels/load-balancer-channels.model';

/**
 * Load balancer channels are shared across clients: they are listed and relabelled only, so this
 * service deliberately exposes no create and no delete. `editOne` sends nothing but `name` and
 * `description` because the API ignores every other field.
 */
@Injectable({
  providedIn: 'root',
})
export class LoadBalancerChannelService {
  private readonly LOAD_BALANCER_CHANNELS_URL = `${this.baseUrl}/api-automation/load-balancer-channels`;

  constructor(
    public http: HttpClient,
    @Inject('API_BASE_URL') private readonly baseUrl: string,
  ) {}

  public getData(params: HttpParams): Observable<GetManyResponseInterface<ILoadBalancerChannel>> {
    return this.http.get<GetManyResponseInterface<ILoadBalancerChannel>>(this.LOAD_BALANCER_CHANNELS_URL, { params });
  }

  public getOne(recordId: number, params?: HttpParams): Observable<BaseOneResponseInterface<ILoadBalancerChannel>> {
    return this.http.get<BaseOneResponseInterface<ILoadBalancerChannel>>(
      `${this.LOAD_BALANCER_CHANNELS_URL}/${recordId}`,
      { params },
    );
  }

  public editOne(
    recordId: number,
    record: ILoadBalancerChannelPatch,
  ): Observable<BaseOneResponseInterface<ILoadBalancerChannel>> {
    return this.http.patch<BaseOneResponseInterface<ILoadBalancerChannel>>(
      `${this.LOAD_BALANCER_CHANNELS_URL}/${recordId}`,
      record,
    );
  }
}
